var React = require('react');

function ContactPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"contact_phone","d":"M9.781,10.883A15.17,15.17,0,0,1,8.641,8.664c.973-.678,2.875-1.53,2.981-2.753C11.757,4.332,9.081,1.03,8.568,1c-1.4.015-3.974,2.391-4.278,3.109C3.724,5.594,4,6.975,4.978,8.975c1.239,2.975,5.841,8.619,8.474,10.39,1.742,1.337,3.015,1.862,4.534,1.545.707-.134,3.258-2.228,3.514-3.643.063-.525-2.9-4.006-4.438-4.144-1.191-.11-2.333,1.673-3.152,2.545a19.3,19.3,0,0,1-1.529-1.511A27.233,27.233,0,0,1,9.781,10.883Z","transform":"translate(-4 -1)","fill":"#628942"}));
}

ContactPhone.defaultProps = {"width":"17.5","height":"20","viewBox":"0 0 17.5 20"};

module.exports = ContactPhone;

ContactPhone.default = ContactPhone;
